<template>
  <div class="promotion-block">
    <div class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/lupa.svg" />
        </div>
        <div class="promo-text">
          Поисковую машину для получения нужной информации за одну минуту при помощи одного запроса
        </div>
      </div>
    </div>
    <div class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/doctor.svg" />
        </div>
        <div class="promo-text">
          Более <span class="accent">1 000</span> практических руководств для врачей первичного звена по <span class="accent">53</span> врачебным специальностям
        </div>
      </div>
    </div>
    <div v-if="!modeMz" class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/plus.svg" />
        </div>
        <div class="promo-text">
          Более <span class="accent">5 000</span> руководств DynaMed Plus для врачей-специалистов всех звеньев здравоохранения
        </div>
      </div>
    </div>
    <div class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/ekg.svg" />
        </div>
        <div class="promo-text">
          Более <span class="accent">1500</span> фотографий дерматологических и глазных заболеваний, рисунков ЭКГ, снимков УЗИ и рентгенограмм
        </div>
      </div>
    </div>
    <div class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/library.svg" />
        </div>
        <div class="promo-text">
          Более <span class="accent">4 000</span> резюме доказательств на основе данных Cochrane Library, поддерживающие данные рекомендации
        </div>
      </div>
    </div>
    <div class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/guides.svg" />
        </div>
        <div class="promo-text">
          Более <span class="accent">200</span> руководств по дифференциальной диагностике, основанных на симптомах и синдромах
        </div>
      </div>
    </div>
    <div class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/video.svg" />
        </div>
        <div class="promo-text">
          Коллекцию видеозаписей клинических исследований и процедур, выполненных опытными специалистами
        </div>
      </div>
    </div>
    <div class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/sound.svg" />
        </div>
        <div class="promo-text">
          Коллекцию аудиозаписей, прежде всего шумов в сердце и легких при различных патологиях
        </div>
      </div>
    </div>
    <div class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/check.svg" />
        </div>
        <div class="promo-text">
          Важнейшие калькуляторы, анкеты и справочники, необходимые врачам-специалистам в практической работе
        </div>
      </div>
    </div>
    <div class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/law.svg" />
        </div>
        <div class="promo-text">
          Нормативные документы МЗ РФ, необходимые врачам и руководителям медицинских организаций в работе
        </div>
      </div>
    </div>
    <div v-if="!modeMz" class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/pharm.svg" />
        </div>
        <div class="promo-text">
          Фармацевтический справочник на основе патогенетического подхода, интегрированный в систему
        </div>
      </div>
    </div>
    <div v-if="!modeMz" class="promotion-card">
      <div class="promotion-content">
        <div class="promo-icon">
          <img src="/icons/home/education.svg" />
        </div>
        <div class="promo-text">
          Учебные программы для терапевтов и педиатров, а также тестовые задания для контроля усвоенного материала
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Promotion",
  computed: {
    modeMz() {
      return window.__env.settings.mode === "mz";
    },
  },
};
</script>

<style scoped></style>
